import { FC, useMemo } from "react";
import { SettingIcon, HomeIcon } from "@components/icons";
import { Button } from "@components/button";
import "./app-menu.scss";
import { useNavigate } from "react-router-dom";
import { AppMenuSchemaType } from "@dialogs/app-add-edit-dialog/app-add-edit-form.schema";
import { darkenColor } from "@utils/color.util";
import { useOutsideClick } from "@hooks/use-outside-click";
import { useIsMinimumTablet } from "@hooks/use-media-query";
import { useAppLive } from "@contexts/live-app.context";
import { Menu } from "./menu";

export const AppMenuNavigate: FC<{
  menuData: AppMenuSchemaType[];
  appId: string;
  secondaryColor?: string;
  primaryColor?: string;
}> = ({ menuData, appId, primaryColor }) => {
  const { showLeftMenu, toggleLeftMenu, dispatch } = useAppLive();
  const isMobile = !useIsMinimumTablet();
  const navigate = useNavigate();

  const fontColor = useMemo(() => {
    if (!isMobile) return "#eeeeee";
    return "#333333";
  }, [isMobile]);

  const menuRef = useOutsideClick<HTMLDivElement>(() => {
    if (isMobile) {
      toggleLeftMenu(false);
    }
    dispatch({ type: "COLLAPSE_ALL" });
  });

  const bgColor = useMemo(
    () => (primaryColor ? darkenColor(primaryColor, 20) : "inherit"),
    [primaryColor],
  );

  return (
    <>
      {showLeftMenu && <div className="menu-mask" />}
      <div
        className={`app-menu-contents ${showLeftMenu ? "" : "absolute"}`}
        style={{ backgroundColor: primaryColor }}
        ref={menuRef}
      >
        <nav role="navigation" aria-label="App Menu Navigation">
          <Menu
            menuData={menuData}
            appId={appId}
            fontColor={fontColor}
            bgColor={bgColor}
            toggleLeftMenu={isMobile ? toggleLeftMenu : undefined}
          />

          <ul className="bottom-menu" style={{ background: isMobile ? "#fcfcfc" : primaryColor }}>
            <div className="menu-bottom-contents">
              <li>
                <Button
                  onClick={() => {
                    dispatch({ type: "COLLAPSE_ALL" });
                    navigate("/apps");
                  }}
                  style={{ color: fontColor }}
                  variant="transparent"
                >
                  <HomeIcon size="11" color={fontColor} />
                  All Apps
                </Button>
              </li>
              <li style={{ marginTop: "1px" }}>
                <Button
                  onClick={() => {
                    dispatch({ type: "COLLAPSE_ALL" });
                    navigate("/apps/settings");
                  }}
                  variant="transparent"
                  style={{ color: fontColor }}
                >
                  <SettingIcon size="11" color={fontColor} />
                  Settings
                </Button>
              </li>
            </div>
          </ul>
        </nav>
      </div>
    </>
  );
};
